import { render } from "./Logo.vue?vue&type=template&id=5a54fdaa&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=5a54fdaa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a54fdaa"]])

export default __exports__